import {INVALID_CLASS_SELECT} from "./consts";

export const validateSelect = (invalidEl) => {
    if (invalidEl.id === 'fake-control' && !!invalidEl.dataset.selectref){
        const currentWrapperRef = document.getElementById(invalidEl.dataset.selectref)
        const currentSelect = currentWrapperRef.children[0].querySelector('div')
        currentSelect.classList.add(INVALID_CLASS_SELECT)
    }

}

export const submitForm = (event,beforeValidateFunc,ref) => {
    return new Promise((resolve, reject) => {
        event.preventDefault();
        event.stopPropagation();
        !!beforeValidateFunc && beforeValidateFunc()

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            const invalidEl = ref.current.querySelector(':invalid');
            invalidEl.scrollIntoView({block: 'center', behavior: 'smooth'});
            reject()
        } else resolve(true)
    })
}

export const submitContainer = (event,ref) =>{
    return new Promise((resolve,reject)=>{
        event.preventDefault();
        event.stopPropagation();
        const invalidEl = ref.current.querySelector(':invalid')
        if(invalidEl) {
            if(invalidEl?.type==='file'){
                const isFilesExists = invalidEl?.offsetParent?.nextSibling?.className === 'file-preview'
                isFilesExists ? resolve(true) : reject('Приложите файл(ы)')
                return
            }
            const label = invalidEl.parentNode?.querySelector('label')?.innerText?.toString()?.replace('*','')
            invalidEl.scrollIntoView({block: 'center', behavior: 'smooth'});
            // кастомные тексты ошибок из элементов <Form.Control.Feedback/> (при наличии); лучше выводить эти сообщения в форме, но под текущую реализацию пока так
            const feedback = invalidEl.parentNode?.querySelector('.invalid-feedback')?.innerText;
            reject(feedback ? feedback : label ? `Поле ${label} не валидно` : 'Проверьте валидность введенных данных')
        }
        else resolve(true)
    })
}
